import { BorderStyle } from '../../../layout/constants'
import { drawRect } from '../../../utils/canvas'
import { calculateSize, calculatePosition } from '../../../utils/image'
import Settings from '../../settings'

const TRANSPARENT = 'transparent'

export default function drawBackground(canvas, style, width, height, image) {
  const radiusList = getBorderRadiusList(style)

  const scale = Settings.VIEW_RESOLUTION
  const actualWidth = width + style.boxShadowSizeLeft + style.boxShadowSizeRight
  const actualHeight = height + style.boxShadowSizeTop + style.boxShadowSizeBottom
  canvas.width = actualWidth * scale
  canvas.height = actualHeight * scale

  const context = canvas.getContext('2d')
  context.scale(scale, scale)

  // Draw shadow
  if (style.withBoxShadow) {
    context.shadowColor = style.boxShadowColor
    context.shadowOffsetX = style.boxShadowOffsetX.value * scale
    context.shadowOffsetY = style.boxShadowOffsetY.value * scale
    context.shadowBlur = style.boxShadowBlurRadius.value * scale
    drawRect(
      context,
      width - 2,
      height - 2,
      radiusList,
      style.boxShadowSizeLeft + 1,
      style.boxShadowSizeTop + 1,
    )
    context.fill()

    context.beginPath()
    context.shadowColor = TRANSPARENT
  }

  // Init context styles
  const borderWidth = style.borderTopWidth.computed
  context.fillStyle = style.backgroundColor || TRANSPARENT
  context.strokeStyle = style.borderTopColor || TRANSPARENT
  context.lineWidth = borderWidth * 2
  if (style.borderTopStyle === BorderStyle.DASHED) {
    let dashLength = borderWidth * 2
    let dashSpace = borderWidth
    if (style.borderDashStyleLength != null) {
      dashLength = style.borderDashStyleLength.value
      dashSpace = style.borderDashStyleSpace.value
    }
    context.setLineDash([dashLength, dashSpace])
  }

  // Draw background color
  drawRect(context, width, height, radiusList, style.boxShadowSizeLeft, style.boxShadowSizeTop)
  context.clip()
  context.fill()

  // Draw background image
  if (image) {
    const { backgroundSize, backgroundPosition } = style
    const { naturalWidth, naturalHeight } = image
    const dWidth = width - borderWidth * 2
    const dHeight = height - borderWidth * 2
    const size = calculateSize(naturalWidth, naturalHeight, dWidth, dHeight, backgroundSize)
    const position = calculatePosition(size.width, size.height, dWidth, dHeight, backgroundPosition)
    context.drawImage(
      image,
      style.boxShadowSizeLeft + borderWidth + position.x,
      style.boxShadowSizeTop + borderWidth + position.y,
      size.width,
      size.height,
    )
  }

  // Apply borders
  if (borderWidth > 0) {
    context.stroke()
  }

  const x = style.boxShadowSizeLeft === 0 ? 0 : -style.boxShadowSizeLeft
  const y = style.boxShadowSizeTop === 0 ? 0 : -style.boxShadowSizeTop
  return { x, y, width: actualWidth, height: actualHeight }
}

function getBorderRadiusList(style) {
  return [
    style.borderTopLeftRadius.value,
    style.borderTopRightRadius.value,
    style.borderBottomRightRadius.value,
    style.borderBottomLeftRadius.value,
  ]
}
